
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconNoCustomer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 98,
  viewBox: "0 0 91 98",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.734 24.706 34.147 38.14M22.355 9.008l52.279 33.628c.738.475.954 1.456.483 2.197m0 0 6.608 4.577a2.083 2.083 0 0 1 .6 2.783m-7.209-7.36-7.451 11.71m14.66-4.35-5.019 7.36a2.522 2.522 0 0 1-3.403.76l-6.238-3.77m0 0a1.993 1.993 0 0 1-2.743.617L45.857 45.167m36.468 7.026 4.276 2.673a4.48 4.48 0 1 1-4.79 7.571l-4.505-2.883M4.33 22.808l2.38 1.636a5.01 5.01 0 0 0 7.11-1.51l7.36-12.008a5.01 5.01 0 0 0-1.617-6.867l-2.271-1.42a5.01 5.01 0 0 0-6.888 1.568L2.936 15.998a5.01 5.01 0 0 0 1.394 6.81Z",
  stroke: "#000",
  strokeWidth: 2.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m33.654 42 1.424 4.49L4.49 82.577a1.838 1.838 0 0 1-2.812-2.368L33.654 42ZM46.434 43.128 44.22 46.74l30.533 36.026a1.976 1.976 0 0 0 3.017-2.553L46.434 43.128ZM42.355 46c-1.993.366-3.088.366-5 0l.878 46.805a2.061 2.061 0 0 0 4.122-.038V46Z",
  stroke: "#810EA9",
  strokeWidth: 2.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.355 41a7.002 7.002 0 0 1-7 7 7 7 0 1 1 7-7Z",
  fill: "#fff",
  stroke: "#810EA9",
  strokeWidth: 2.692
})));

      const __svgRaw = "<svg width=\"91\" height=\"98\" viewBox=\"0 0 91 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M12.7339 24.7055L34.1466 38.1413M22.3547 9.00841L74.634 42.6363C75.3719 43.1109 75.5875 44.0925 75.1165 44.8327M75.1165 44.8327L81.7249 49.4097C82.6271 50.0345 82.8896 51.2523 82.325 52.1933M75.1165 44.8327L67.6646 56.5428M82.325 52.1933L77.3064 59.5539C76.5579 60.6767 75.0582 61.0114 73.9033 60.3134L67.6646 56.5428M67.6646 56.5428C67.0758 57.4681 65.8501 57.7438 64.9217 57.1598L45.8566 45.1673M82.325 52.1933L86.6007 54.8656C88.6811 56.1659 89.3286 58.8978 88.0529 60.9934C86.746 63.1405 83.9288 63.7922 81.8117 62.4373L77.3064 59.5539M4.33034 22.8076L6.71025 24.4438C9.07534 26.0698 12.3203 25.3804 13.8201 22.9334L21.1796 10.9258C22.6165 8.58126 21.8952 5.51669 19.5633 4.05928L17.2917 2.63949C14.9552 1.1792 11.8781 1.87964 10.4038 4.20735L2.9361 15.9985C1.49497 18.274 2.11083 21.2817 4.33034 22.8076Z\" stroke=\"black\" stroke-width=\"2.5\"/>\r\n<path d=\"M33.6545 42L35.0779 46.4907L4.49049 82.5759C3.79385 83.3978 2.54297 83.4471 1.78382 82.6826C1.11457 82.0086 1.06891 80.9358 1.67848 80.2075L33.6545 42Z\" stroke=\"#810EA9\" stroke-width=\"2.5\"/>\r\n<path d=\"M46.4345 43.1279L44.219 46.7406L74.7518 82.767C75.4839 83.6309 76.7907 83.7042 77.6149 82.9276C78.3791 82.2076 78.4468 81.0157 77.7692 80.2136L46.4345 43.1279Z\" stroke=\"#810EA9\" stroke-width=\"2.5\"/>\r\n<path d=\"M42.3547 46C40.3615 46.3658 39.2667 46.3659 37.3547 46.0001L38.2327 92.8054C38.255 93.9945 39.2762 94.918 40.4616 94.8211C41.5312 94.7336 42.3547 93.8399 42.3547 92.7667L42.3547 46Z\" stroke=\"#810EA9\" stroke-width=\"2.5\"/>\r\n<path d=\"M47.3547 41C47.3547 41.4559 47.3111 41.9017 47.2279 42.3333C46.6053 45.5616 43.7648 48 40.3547 48C36.4887 48 33.3547 44.866 33.3547 41C33.3547 37.134 36.4887 34 40.3547 34C44.2207 34 47.3547 37.134 47.3547 41Z\" fill=\"white\" stroke=\"#810EA9\" stroke-width=\"2.69231\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon_no_customer.bf52ee35e316010d873f175a18006f2d.svg"),
        {
          React: SvgIconNoCustomer,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      